import { render } from "./SugarList.vue?vue&type=template&id=28ace508&scoped=true&ts=true"
import script from "./SugarList.vue?vue&type=script&lang=ts"
export * from "./SugarList.vue?vue&type=script&lang=ts"

import "./SugarList.vue?vue&type=style&index=0&id=28ace508&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ace508"]])

export default __exports__